import { render, staticRenderFns } from "./UpdateAward.vue?vue&type=template&id=5fc23a92&scoped=true"
import script from "./UpdateAward.vue?vue&type=script&lang=js"
export * from "./UpdateAward.vue?vue&type=script&lang=js"
import style0 from "./UpdateAward.vue?vue&type=style&index=0&id=5fc23a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc23a92",
  null
  
)

export default component.exports